import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'utils/isNil';
import styled from 'styled-components';
import { WebsiteImage } from 'components/TitleDescription';

const CompanyLetterSection = ({ background, title, letter, ...otherProps }) => {
  return (
    <SectionCompanyLetter background={background} {...otherProps}>
      <div className="section-company-letter--container">
        <h2 className="section-company-letter--title">{title}</h2>
        <div className="section-company-letter--main">
          {!isNil(letter.bodyTop) && (
            <p className={'section-company-letter--letter-normal'}>{letter.bodyTop.bodyTop}</p>
          )}

          {!isNil(letter.blockQuote) && (
            <p className={'section-company-letter--letter-special'}>{letter.blockQuote}</p>
          )}

          {!isNil(letter.bodyBottom) && (
            <p className={'section-company-letter--letter-normal'}>
              {letter.bodyBottom.bodyBottom}
            </p>
          )}

          {!isNil(letter.author) && (
            <p className={'section-company-letter--letter-writer'}>{letter.author}</p>
          )}

          <div className="section-company-letter--letter-sign-container">
            <div className="section-company-letter--letter-sign">
              {letter.signature.map((signItem, index) => {
                return <WebsiteImage src={signItem} key={index} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </SectionCompanyLetter>
  );
};

CompanyLetterSection.propTypes = {
  title: PropTypes.string,
  background: PropTypes.string,
  letter: PropTypes.object,
};

const SectionCompanyLetter = styled.div`
  background: ${props => props.background};

  .section-company-letter--container {
    padding: 72px 28px;
    margin: 0 auto;
    text-align: center;

    .section-company-letter--title {
      font-weight: 900;
      font-size: 49px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: var(--normal-title-color);
      max-width: 899px;
      margin: 0 auto;
    }

    .section-company-letter--main {
      margin-top: 75px;

      .section-company-letter--letter-normal {
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        color: var(--normal-description-color);
        text-align: left;
        max-width: 684px;
        margin: 0 auto 18px;
      }

      .section-company-letter--letter-special {
        font-weight: 900;
        font-size: 25px;
        line-height: 120%;
        letter-spacing: -0.02em;
        color: var(--normal-description-color);
        text-align: left;
        max-width: 751px;
        padding: 41px 33px;
        box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
        background: var(--white-color);
        margin: 46px auto 61px;
        position: relative;

        &:before {
          content: ' ';
          width: 16px;
          height: 60px;
          background: var(--secondary-green-background);
          left: -16px;
          top: -16px;
          position: absolute;
        }

        &:after {
          content: ' ';
          width: 60px;
          height: 16px;
          background: var(--secondary-green-background);
          left: -16px;
          top: -16px;
          position: absolute;
        }
      }

      .section-company-letter--letter-writer {
        font-weight: bold;
        font-size: 20px;
        line-height: 120%;
        letter-spacing: -0.01em;
        color: var(--normal-description-color);
        text-align: left;
        max-width: 684px;
        margin: 25px auto 0;
      }

      .section-company-letter--letter-sign-container {
        max-width: 684px;
        margin: 40px auto 0 auto;
        align-items: center;
      }

      .section-company-letter--letter-sign {
        max-width: 396px;
        align-items: flex-start;
      }
    }
  }

  @media (max-width: 991px) {
  }

  @media (max-width: 768px) {
    .section-company-letter--container {
      padding: 48px 28px;

      .section-company-letter--title {
        font-size: 29px;
        letter-spacing: -0.03em;
      }

      .section-company-letter--main {
        margin-top: 32px;

        .section-company-letter--letter-normal {
          font-size: 16px;
          max-width: 466px;
        }

        .section-company-letter--letter-special {
          font-size: 20px;
          padding: 24px;
          max-width: 466px;
          margin-top: 46px;
          margin-bottom: 40px;

          &:before {
            width: 14px;
            height: 50px;
            left: -14px;
            top: -14px;
          }

          &:after {
            width: 50px;
            height: 14px;
            left: -14px;
            top: -14px;
          }
        }

        .section-company-letter--letter-writer {
          font-size: 18px;
          max-width: 466px;
        }

        .section-company-letter--letter-sign-container {
          max-width: 466px;
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-company-letter--container {
      padding: 48px 20px;
    }

    .section-company-letter--letter-sign {
      max-width: 240px !important;
    }
  }
`;

export default CompanyLetterSection;
